"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoalSource = void 0;
var GoalSource;
(function (GoalSource) {
    GoalSource["Journal"] = "journal";
    GoalSource["Personal"] = "personal";
})(GoalSource = exports.GoalSource || (exports.GoalSource = {}));
